import { useEffect, useRef, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
// import ClickAwayListener from '@mui/material/ClickAwayListener';
// import Grid from '@mui/material/Grid';
// import List from '@mui/material/List';
// import ListItemButton from '@mui/material/ListItemButton';
// import ListItemText from '@mui/material/ListItemText';
// import Paper from '@mui/material/Paper';
// import Popper from '@mui/material/Popper';
// import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Dialog from '@mui/material/Dialog';
// import DialogTitle from '@mui/material/DialogTitle';
// import Divider from '@mui/material/Divider';

// project imports
// import Transitions from 'ui-component/extended/Transitions';

// assets
// import TranslateTwoToneIcon from '@mui/icons-material/TranslateTwoTone';
import useConfig from 'hooks/useConfig';

// types
import { I18n } from 'types/config';

import ForgotPassword from 'views/pages/authentication/ForgotPassword3';
import { FormattedMessage } from 'react-intl';

interface SimpleDialogProps {
    onClose: (s: string) => void;
    selectedValue: string;
    open: boolean;
}

// ==============================|| LOCALIZATION ||============================== //

const ForgotPasswordSection = ({ forgotForceOpen, forceOpen }: { forgotForceOpen: boolean; forceOpen: Function }) => {
    const { mode, borderRadius, i18n, onChangeLocale } = useConfig();

    const theme = useTheme();
    const downMD = useMediaQuery(theme.breakpoints.down('md'));

    const [open, setOpen] = useState(forgotForceOpen || false);
    const anchorRef = useRef<any>(null);

    const handleListItemClick = (
        event: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLDivElement, MouseEvent> | undefined,
        lng: I18n
    ) => {
        onChangeLocale(lng);
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event: MouseEvent | TouchEvent) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
        forceOpen('close');
    };

    const prevOpen = useRef(open);

    // useEffect(() => {
    //     if (prevOpen.current === true && open === false) {
    //         anchorRef.current.focus();
    //     }
    //     prevOpen.current = open;
    // }, [open]);

    useEffect(() => {
        if (forgotForceOpen) setOpen(true);
    }, [forgotForceOpen]);

    const forceOpenFn = (type: string) => {
        forceOpen(type);
        setOpen(false);
    };
    return (
        <>
            {open && (
                <Dialog sx={{ borderRadius: '0px' }} onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
                    {open && (
                        <>
                            <Card className="343434" sx={{ overflow: 'auto', borderRadius: '0px', background: 'transparent' }}>
                                <CardContent sx={{ p: 0, borderRadius: '0px', background: '#fff', pb: '0px !important' }}>
                                    <ForgotPassword forceOpen={forceOpenFn} />
                                </CardContent>
                            </Card>
                        </>
                    )}
                </Dialog>
            )}
        </>
    );
};

export default ForgotPasswordSection;
